/**
 * CitationSyncPlugin.js
 *
 * ProseMirror plugin that hooks into appendTransaction to run
 * syncCitationOrder() after every document change.
 *
 * Usage: import this and add it to the wax config plugins array.
 */

import { Plugin } from 'prosemirror-state';
import { syncCitationOrder, debounce } from './syncCitationOrder';

let viewRef = null;
const debouncedSync = debounce((view) => syncCitationOrder(view), 400);

export const CitationSyncPlugin = new Plugin({
  view(editorView) {
    viewRef = editorView;

    const handleForceSync = () => {
      if (viewRef) syncCitationOrder(viewRef);
    };
    window.addEventListener('forceCitationSync', handleForceSync);

    return {
      destroy() {
        window.removeEventListener('forceCitationSync', handleForceSync);
        viewRef = null;
      },
    };
  },

  appendTransaction(transactions, _oldState, newState) {
    const docChanged = transactions.some((tr) => tr.docChanged);
    if (docChanged && viewRef) {
      // Run debounced – we need the real view (with dispatch), not the snapshot
      debouncedSync(viewRef);
    }
    return null; // we handle the transaction ourselves inside syncCitationOrder
  },
});

export default CitationSyncPlugin;
